module.exports = __webpack_public_path__ + "static/media/exchange-rate-image.71b2e1a3.PNG";